<template>
  <div>
    <div>
      <template 
        v-if="!!departureDate"
      >
        {{ departureDate }} | 
      </template>
      <span class="fw-bold">{{ departureTime }} </span> 
      {{ departure?.airportName }} ({{ departure?.airportId }})
    </div>

    <div class="d-flex my-2">
      <div class="d-flex flex-column justify-content-between">
        <div :class="!hasFeeder || isOutboundFlight ? 'bullet-green' : 'bullet-orange'" />
        <div :class="!hasFeeder ? 'line-grey' : 'line-grey-stop'" />
        <div :class="!hasFeeder || !isOutboundFlight ? 'bullet-green' : 'bullet-orange'" />
      </div>

      <div class="d-flex flex-column justify-content-center ms-3">
        <div v-if="!!flight?.airline.flightNumber">
          {{ flight.airline.id }} {{ flight.airline.flightNumber }}
        </div>
        <div v-if="!!flight?.airline.name">
          {{ flight.airline.name }}
          <template v-if="!!flight.airline.operatedBy && !!flight.airline.operatedByName">
            | durchgeführt von
            {{ flight.airline.operatedByName }}
          </template>
        </div>
        <div>{{ flight?.flightClass.name }} {{ rnfInfoText }}</div>
      </div>
    </div>

    <div>
      <template v-if="!!arrivalDate">
        {{ arrivalDate }} | 
      </template>
      <span class="fw-bold">{{ arrivalTime }} </span>
      {{ arrival?.airportName }} ({{ arrival?.airportId }})
    </div>
  </div>
</template>

<script lang="ts">
import { IAirportData } from '@/store/details/flight/interfaces';
import { PropType, defineComponent } from 'vue';
import {
    DEFAULT_DATE_FORMAT_WITH_WEEKDAY,
    DEFAULT_TIME_FORMAT,
    convertFormat,
    getValidDateFormat,
} from '../../../general/helper';

export default defineComponent({
  props: {
    info: { type: Object as PropType<IAirportData>, default: () => undefined },
    departure: { type: Object, default: () => undefined },
    arrival: { type: Object, default: () => undefined },
    flight: { type: Object, default: () => undefined },
    hasFeeder: { type: Boolean, default: false },
    isOutboundFlight: { type: Boolean, default: false },
    rnfInfoText: { type: String, default: '' },
  },

  computed: {
    departureDate() {
      return !!this.departure?.time
        ? convertFormat(this.departure.time, getValidDateFormat(this.departure.time), DEFAULT_DATE_FORMAT_WITH_WEEKDAY)
        : ''
    },
    arrivalDate() {
      return !!this.arrival?.time
        ? convertFormat(this.arrival.time, getValidDateFormat(this.arrival.time), DEFAULT_DATE_FORMAT_WITH_WEEKDAY)
        : ''
    },
    departureTime() {
      return !!this.departure?.time
        ? convertFormat(this.departure.time, getValidDateFormat(this.departure.time), DEFAULT_TIME_FORMAT)
        : ''
    },
    arrivalTime() {
      return !!this.arrival?.time
        ? convertFormat(this.arrival.time, getValidDateFormat(this.arrival.time), DEFAULT_TIME_FORMAT)
        : ''
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.bullet-green {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: $color-expinet-green;
}

.line-grey {
  margin-left: 2px;
  margin-top: 2px;
  margin-bottom: 2px;
  width: 2px;
  min-height: 10px;
  background-color: $color-expinet-gray;
  height: calc(100% - 20px);
}

.bullet-orange {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 1px;
  background-color: $color-aida-yellow;
}

.line-grey-stop {
  margin-left: 2px;
  margin-top: 2px;
  margin-bottom: 2px;
  width: 2px;
  height: calc(100% - 20px);
  background-color: $color-expinet-gray;
}
</style>
